import { cn } from 'root/src/client/v2/common/helpers/cn';
const pillClass = (active) => cn('rounded-lg border border-solid px-3 py-1.5 text-xs font-medium transition-colors', active
    ? 'border-primary/40 bg-primary/15 text-foreground'
    : 'border-white/[0.08] bg-white/[0.02] text-muted-foreground hover:border-white/20 hover:text-foreground');
// Single-select segmented pills. Used for small enums (difficulty, reward-for) where a
// dropdown would be heavier than the redesign needs.
export function PillSelect({ value, onChange, options, className }) {
    return (<div className={cn('flex flex-wrap gap-2', className)}>
			{options.map(option => (<button key={option.value} type="button" onClick={() => onChange(option.value)} className={pillClass(option.value === value)}>
					{option.label}
				</button>))}
		</div>);
}
// Multi-select segmented pills (dare platforms).
export function PillMultiSelect({ values, onChange, options, className }) {
    const toggle = (value) => {
        onChange(values.includes(value) ? values.filter(item => item !== value) : [...values, value]);
    };
    return (<div className={cn('flex flex-wrap gap-2', className)}>
			{options.map(option => (<button key={option.value} type="button" onClick={() => toggle(option.value)} className={pillClass(values.includes(option.value))}>
					{option.label}
				</button>))}
		</div>);
}
